import { render } from "./ShopHome.vue?vue&type=template&id=65b205af&scoped=true"
import script from "./ShopHome.vue?vue&type=script&lang=js"
export * from "./ShopHome.vue?vue&type=script&lang=js"

import "./ShopHome.vue?vue&type=style&index=0&id=65b205af&scoped=true&lang=css"
import "./ShopHome.vue?vue&type=style&index=1&id=65b205af&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b205af"]])

export default __exports__